import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Task } from '../../tasks/models';
import TaskLink from '../../tasks/Maintenance/components/TaskLink';
import { LinkedTaskField } from '../../tasks/components/LinkedTaskField';
import { selectTasks } from '../../tasks/reducer';
import { fetchTasks } from '../../tasks/actions';

interface TaskLinkedTabProps {
  task?: Task;
  editing?: boolean;
}

export const TaskLinkedTab = ({ task, editing = false }: TaskLinkedTabProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const tasks = useSelector(selectTasks);

  useEffect(() => {
    if (tasks.length == 0) {
      dispatch(fetchTasks());
    }
  }, []);

  return (
    <>
      {editing ? (
        <LinkedTaskField name="linkedTaskTemplates" tasks={tasks} />
      ) : (
        <TaskLink intl={intl} task={task} />
      )}
    </>
  );
};
